@if (stories) {
    <ms-slideshow
        [realtotalslidecount]="stories.length"
        [slideIndex]="activeStory"
        [disableSwipe]="disableDesktopSwipe"
        [circular]="false"
        (slideChanged)="storySlideChanged($event)"
        (slideChanged)="storySlideChanged($event)"
        (swipeNotApplicable)="closePopup()">
        @for (story of stories; track story.id; let storyIndex = $index) {
            <ms-slide>
                <div class="story-header">
                    <div class="duration-bar-container">
                        @for (subStory of story.subStories; let subStoryIndex = $index; track subStory.id) {
                            <div
                                class="duration-bar"
                                [class.filled]="subStoryIndex < activeSubStory"
                                [class.unfilled]="subStoryIndex > activeSubStory"
                                [style.width]="progressBarWidth[subStory.id]">
                                @if (storyIndex === activeStory && subStoryIndex === activeSubStory) {
                                    <ms-timer-progress-bar
                                        [totalDuration]="subStory.duration"
                                        [loop]="false"
                                        [pauseProgressBar]="progressBarPaused"
                                        [smoothProgressTransition]="true"
                                        (complete)="nextSubStory(false, story.id, subStory.id)" />
                                }
                            </div>
                        }
                    </div>
                    <div class="story-title-container">
                        <span class="story-title">{{ story.title }}</span>
                        <a class="theme-ex close" (click)="closePopup(true, true)"></a>
                    </div>
                </div>
                @if (storyIndex === activeStory) {
                    <div class="story-body-container" [@storySlideAnimation]>
                        <ms-story-body
                            [stories]="stories"
                            [activeStory]="activeStory"
                            [paused]="progressBarPaused"
                            [activeSubStory]="activeSubStory"
                            (close)="closePopup()" />
                    </div>
                }
            </ms-slide>
        }
    </ms-slideshow>
}
@if (showRotationMessage) {
    <ms-rotation-message (close)="closePopup(false)" />
}
